import type { SvgIconProps } from '@mui/material/SvgIcon';
import { RTMPatientStatusResponseDTO } from 'artifacts/dtos';
import RTMIcon from 'assets/svg/RTMIcon';
import type { ComponentType } from 'react';
import { ModuleTypes } from 'types/appState';
import { isEmptyString } from 'utils/helper';

export type RtmKind = 'enrollment' | 'checkIn';

export type RtmChoice = {
  kind: RtmKind;
  token: string | null;
  isComplete: boolean;
};

export type RtmCardCopy = {
  icon: ComponentType<SvgIconProps>;
  title: string;
  subtitle: string;
  startLabel: string;
};

export function getRtmChoice(
  status?: RTMPatientStatusResponseDTO | null,
): RtmChoice | null {
  const enrollment = status?.enrollment;
  const latestCheckIn = status?.latestCheckIn;

  const hasPendingEnrollment = !isEmptyString(enrollment?.token)
    && !enrollment?.isComplete;
  if (hasPendingEnrollment) {
    return {
      kind: 'enrollment',
      token: enrollment?.token ?? '',
      isComplete: false,
    };
  }

  const hasPendingCheckIn = !isEmptyString(latestCheckIn?.token)
    && !latestCheckIn?.isComplete;
  if (hasPendingCheckIn) {
    return {
      kind: 'checkIn',
      token: latestCheckIn?.token ?? '',
      isComplete: false,
    };
  }

  if (!isEmptyString(latestCheckIn?.token) && latestCheckIn?.isComplete) {
    return {
      kind: 'checkIn',
      token: latestCheckIn?.token ?? null,
      isComplete: true,
    };
  }

  if (!isEmptyString(enrollment?.token) && enrollment?.isComplete) {
    return {
      kind: 'enrollment',
      token: enrollment?.token ?? null,
      isComplete: true,
    };
  }

  return null;
}

const rtmCardCopies: readonly RtmCardCopy[] = Object.freeze([
  {
    icon: RTMIcon,
    title: 'Treatment Progress Enrollment',
    subtitle: 'Enrollment · about 1 minute',
    startLabel: 'Enroll',
  },
  {
    icon: RTMIcon,
    title: 'Treatment Progress Check-In Survey',
    subtitle: 'Check-in · about 1 minute',
    startLabel: 'Start',
  },
]);

export function getRtmCardCopy(kind: RtmKind): RtmCardCopy {
  return rtmCardCopies[Number(kind === 'checkIn')];
}

export function getRtmModuleType(kind: RtmKind) {
  return kind === 'enrollment'
    ? ModuleTypes.rtmEnrollment
    : ModuleTypes.rtmCheckIn;
}
